import styled from "styled-components";
import { Link } from "react-router-dom";

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Row = styled.div<{ $highlighted: boolean }>`
  align-items: center;
  background: ${({ $highlighted }) =>
    $highlighted ? "rgba(143, 169, 175, 0.1)" : "transparent"};
  border-radius: 8px;
  display: grid;
  gap: 10px;
  grid-template-columns: 22px auto 1fr auto;
  padding: 6px 8px;
`;

export const Rank = styled.span<{ $color?: string }>`
  color: ${({ $color, theme }) => $color ?? theme.colors.chalk};
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
`;

export const NameLink = styled(Link)<{ $color?: string }>`
  color: ${({ $color, theme }) => $color ?? theme.colors.ice};
  font-size: 13px;
  font-weight: 700;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export const YouLabel = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 12px;
  font-weight: 600;
`;

export const Score = styled.span`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
`;
